export const ExportGeometryFormat: {[key: string]: Array<string>} = {
    DWG: [
        'format=DWG',
        'hideSubArticles=false',
        'materials=true',
        'no2D=true',
        'textures=true',
        'edwg=true'
    ],
    DXF: [
        'format=DWG',
        'dxf=true',
        'hideSubArticles=false',
        'no2D=true',
        'textures=true',
        'materials=true'
    ],
    FBX: [
        'format=FBX',
        'hideSubArticles=false',
        'scale=1.0',
        'textures=true',
        'materials=true',
        'no2D=true',
        'textureToColor=false',
        'duplicateFaces=true'
    ],
    '3DS': [
        'format=3DS',
        'hideSubArticles=false',
        'textures=true'
    ],
    SKP: [
        'format=SKP',
        'hideSubArticles=false',
        'no2D=true',
        'textures=false',
        'textureToColor=true'
    ],
    DWG_KOMPAN: [
        'format=DWG',
        'hideSubArticles=false',
        'scale=1.0',
        'use3DProxies=true',
        'materials=true',
        'no2D=false',
        'no3D=false',
        'olayers=false',
        'r17=true',
        'dxf=false',
        'annotation=false',
        'edwg=true'
    ]
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/ExportGeometryFormats.ts